
<div class="flex-h edit-row" *ngIf="groupGoal && data">
    <div class="flex1 own-group-goal-panel">
        <mat-form-field appearance="outline" class="width-max hidden-print">
            <mat-label>{{ 'GROUP_GOAL_EDIT.MY_TEAM_GOAL' | translate }}</mat-label>
            <textarea matInput 
                [disabled]="!allowEdit()" rows="3" 
                name="groupGoalName" 
                [(ngModel)]="groupGoal.name" title="{{ groupGoal.name }}" autocomplete="off" (change)="groupGoalChanged($event)" required
            ></textarea>
        </mat-form-field>
        <p class="form-control visible-print">{{ groupGoal.name }}</p>
    </div>
    
    <div class="flex1 parent-group-goal-panel">
        <app-group-goal-field             
            [data]="data"
            [groupGoal]="groupGoal.parentGroupGoal"
            [editLabel]="'GROUP_GOAL_EDIT.LEADER_RELATED_TEAM_GOAL' | translate"
            (change)="parentGroupGoalChanged($event)"
        ></app-group-goal-field>
        
        <!-- floating button -->
        <button mat-icon-button color="primary" class="goal-delete hidden-print icon-button" [disabled]="!allowDelete()" *ngIf="isSelf" (click)="deleteGroupGoal()" title="{{ 'GROUP_GOAL_EDIT.DELETE_TEAM_GOAL' | translate }}">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
